import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App.js';
import { store } from './redux/store';
import './fonts/OriginalGaramondCBT.ttf';
import './fonts/OriginalGaramondSCCBT.ttf';
import './fonts/OriginalGaramondCBT-Bold.ttf';
import './fonts/OriginalGaramondCBT-Italic.ttf';
import './fonts/OriginalGaramondCBT-BoldItalic.ttf';
import './fonts/proximanova_black.ttf';
import './fonts/proximanova_light.otf';
import './fonts/proximanova_regular.ttf';
import './index.css';
import { BrowserRouter } from 'react-router-dom';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <div className="index">
        <App />
      </div>
      
    </Provider>
  </BrowserRouter>

);


